import { useEffect, useState } from "react";

import { QuizStepProps } from "../useQuestionnaire";

import { Option } from "./components/Option";

const optionList = [
  {
    name: "Yes, I currently take or have recently (within the last 12 months) taken a GLP-1 medication for weight loss.",
    value: "YesGLP1",
  },
  {
    name: "Yes, I currently take or have recently (within the last 12 months) taken another medication for weight loss.",
    value: "YesOther",
  },
  { name: "No", value: "No" },
];

export const WeightLossMeds = (props: QuizStepProps) => {
  const [lastUpdate, setLastUpdate] = useState<{
    key: string;
    value: string;
  } | null>(null);
  const hasError =
    props.errors !== null && props.errors.WeightLossMeds !== undefined;

  const handleChange = (key: string, value: string) => {
    props.handleStepData(key, value);
    setLastUpdate({ key, value });
  };

  useEffect(() => {
    if (props.next && lastUpdate) {
      props.next();
    }
  }, [props.next, props, lastUpdate]);

  return (
    <div>
      <p className="pb-8 font-serif text-h3">
        Are you currently taking or have recently (within the last 12 months)
        taken medication(s) for weight loss?
      </p>
      <div>
        <div className="flex flex-col items-start space-y-2" key="Meds">
          {optionList.map((option) => (
            <Option
              className="w-full text-center"
              name={option.name}
              key={option.value}
              value={option.value}
              checked={props.data.WeightLossMeds === option.value}
              onChange={() => handleChange("WeightLossMeds", option.value)}
            />
          ))}
        </div>
        {hasError && (
          <div className="text-label mt-2 text-red">
            * Please choose one option
          </div>
        )}
      </div>
    </div>
  );
};
